module.exports = __webpack_public_path__ + "img/results-black.67d3628d.svg";